import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "../../../../components/ui/Modal";
import { Button } from "../../../../components/ui/Button";

// SVG inline en lugar de lucide Unlink/Unlink2 porque el nombre del icono ha
// cambiado entre versiones del paquete y no queremos depender del lockfile.
function UnlinkIcon(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71" />
      <path d="m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71" />
      <line x1="8" x2="16" y1="2" y2="2" />
      <line x1="2" x2="5" y1="22" y2="22" />
      <line x1="2" x2="2" y1="15" y2="20" />
      <line x1="22" x2="22" y1="11" y2="20" />
    </svg>
  );
}

export default function DisconnectModal({ isOpen, toggle, integration, onConfirm }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  if (!integration) return null;

  const name =
    integration.display_name ||
    integration.phone_number ||
    integration.page_name ||
    t("esta cuenta");

  const handleConfirm = async () => {
    setLoading(true);
    await onConfirm(integration.id);
    setLoading(false);
    toggle();
  };

  return (
    <Modal
      open={isOpen}
      onClose={() => !loading && toggle()}
      hideClose
      size="sm"
      ariaLabel={t("Desconectar integración")}
      footer={
        <>
          <Button variant="ghost" size="sm" onClick={toggle} disabled={loading}>
            {t("Cancelar")}
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={handleConfirm}
            loading={loading}
          >
            {loading ? t("Desconectando…") : t("Desconectar")}
          </Button>
        </>
      }
    >
      <div className="flex items-center justify-center w-10 h-10 rounded-full bg-status-error-soft text-status-error mb-3">
        <UnlinkIcon className="w-5 h-5" />
      </div>
      <h3 className="text-base font-semibold text-fg">
        {t("Desconectar integración")}
      </h3>
      <p className="mt-1 text-sm text-fg">
        {t("¿Seguro que deseas desconectar")} <strong>{name}</strong>?
      </p>
      <p className="mt-2 text-xs text-fg-muted leading-relaxed">
        {t("Se revocarán los permisos en Meta y dejarás de recibir mensajes de este canal. Puedes reconectarlo cuando quieras.")}
      </p>
    </Modal>
  );
}
